/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_viewer">;
    readonly " $refType": "PdpSharedContactDealerButton_viewer";
};
export type PdpSharedContactDealerButton_viewer$data = PdpSharedContactDealerButton_viewer;
export type PdpSharedContactDealerButton_viewer$key = {
    readonly " $data"?: PdpSharedContactDealerButton_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedContactDealerButton_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'a4a6eda9fbc3c3585ab7f7ca3bc631df';
export default node;
